
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { SingularityUIState } from "@/store/modules/singularity";
import { singularityStore } from "@/store/store";
import { NavLink } from "./TopNavBuilder.vue";

@Component({
  components: {
    Icon
  }
})
export default class SideNavButton extends Vue {
  @Prop() link!: NavLink;

  openPanel(panelState?: SingularityUIState["singularityLeftPanel"]) {
    if (!panelState) {
      return;
    }
    singularityStore.setSingularityLeftPanel(panelState);
  }

  get isActive() {
    return (
      singularityStore.singularityUiState.singularityLeftPanel ===
      this.link.panelState
    );
  }

  handleClick() {
    if (this.link.action) {
      this.link.action();
    } else {
      this.openPanel(this.link.panelState);
    }
  }
}
